import React, { useEffect, useState } from "react";
import Modal from 'react-bootstrap/Modal';
import Carousel from "react-bootstrap/Carousel";
import { LoginService } from "../../../services";

function ImageCarousel(props) {
  const [index, setIndex] = useState(props.index);
  const user = LoginService.getUser();


  useEffect(() => {
    setIndex(props.index)
  }, [ props.index ])

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  return (
    <Modal
      size="xl"
      show={true}
      onHide={props.onClose}
      animation={false}
      centered
    >
      <Modal.Body>
        <Carousel activeIndex={index} onSelect={handleSelect} interval={null}>
          {props.images.map((imageId) => {
            const imageURL = `https://service.orthomagic.com.tr:8447/OrthoMagic/GetImage?ImageId=${imageId}&GUID=${user.SessionGUID}&UserId=${user.UserId}`;
            return (
              <Carousel.Item>
                <img className="d-block w-100" src={imageURL} />
              </Carousel.Item>
            );
          })}
        </Carousel>
      </Modal.Body>
    </Modal>
  );
}

export default ImageCarousel;
